import React, { Component } from 'react';
import SnackbarContent from '@material-ui/core/SnackbarContent';

class StaticRelationList extends Component {
    render() {

        const mappedItems = this.props.items.map(i => {
            return (
                <div className="DetailItem" key={i.id}>
                    <SnackbarContent className="AlreadySelected" message={i.label}>
                    </SnackbarContent>
                </div>
            )
        })

        const blankDiv = <div className='detailPlaceholder'> </div>

        return (

            <div className={this.props.rootClass}>
                <h1 className='DetailHeader'>{this.props.header}</h1>
                {mappedItems}
                {blankDiv}
            </div>

        )
    }
}

export default StaticRelationList;


// WEBPACK FOOTER //
// src/main/components/StaticRelationList.js